import moment from "moment"

import { DATETIME_FORMAT, TIME_FORMAT, TIME_FORMAT_12 } from "modules/datepicker/constants"

export const isDateInRange = (start, end, day) => {
  const momentDay = moment(day)
  const startOfDay = momentDay.clone().startOf("day")
  const endOfDay = momentDay.clone().endOf("day")

  const momentStart = moment(start, DATETIME_FORMAT)
  const momentEnd = moment(end, DATETIME_FORMAT)

  const includes = momentStart.isSameOrBefore(momentDay, "day") && momentEnd.isSameOrAfter(momentDay, "day")
  const wholeDayInRange = momentStart.isSameOrBefore(startOfDay) && momentEnd.isSameOrAfter(endOfDay)

  return { includes, wholeDayInRange }
}

export const timeTo12 = (time) => moment(time, TIME_FORMAT).format(TIME_FORMAT_12)

// Raw (untranslated) sentinel values formatDayLabel can return, so callers can
// map them through t() without hardcoding the English strings a second time.
export const DAY_LABEL_TODAY = "Today"
export const DAY_LABEL_YESTERDAY = "Yesterday"

/**
 * Today -> Yesterday -> weekday name (last 7 days) -> "Month D" ladder shared by
 * every chat-style day divider in the app (Messages, AI Assistant), so they can't
 * drift into disagreeing formats again.
 * @param {string|number|Date} dateInput
 * @returns {string}
 */
export const formatDayLabel = (dateInput) => {
  const date = moment(dateInput)
  const now = moment()
  if (date.isSame(now, "day")) return DAY_LABEL_TODAY
  if (date.isSame(now.clone().subtract(1, "day"), "day")) return DAY_LABEL_YESTERDAY
  if (now.diff(date, "days") < 7) return date.format("dddd") // e.g., Wednesday
  return date.format("MMMM D") // e.g., September 26
}

/**
 * Parses an API date-only string ("YYYY-MM-DD") into a Date representing that
 * calendar day in the browser's local timezone.
 * `new Date("YYYY-MM-DD")` parses as UTC midnight per the ES spec, which then
 * shifts to the previous/next local day when rendered via toLocaleDateString -
 * this avoids that rollover by building the Date from local year/month/day parts.
 * @param {string} dateOnly - Date-only string, e.g. "2025-09-10"
 * @returns {Date|null}
 */
export const parseDateOnly = (dateOnly) => {
  if (!dateOnly) return null
  const [year, month, day] = String(dateOnly).slice(0, 10).split("-").map(Number)
  if (!year || !month || !day) return null
  return new Date(year, month - 1, day)
}
